module.exports = __webpack_public_path__ + "img/logo.cdb9c99c.png";